module.exports = __webpack_public_path__ + "static/media/Phone.7deedd4b.svg";